var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{
        'fullscreen': _vm.fullscreen
    }},[_c('b-spinner',{attrs:{"variant":"primary","label":"Loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }